// @owners { team: patients-team }
import { createSelector } from 'reselect';
import { getCurrentUserLabels } from './getCurrentUserLabels';

// To match the GSK4U label from Scriptdash app/services/partnerships/gsk_for_you.rb
const GSK_FOR_YOU_LABEL = 'gsk_for_you';

export const getIsGskForYouUser = createSelector([getCurrentUserLabels], (labels) => {
  return labels.includes(GSK_FOR_YOU_LABEL);
});
